import { render, staticRenderFns } from "./responsive-btn.vue?vue&type=template&id=55059036&"
import script from "./responsive-btn.vue?vue&type=script&lang=ts&"
export * from "./responsive-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports